'use strict';

function isObject(value) {
    return typeof value === "object" && value !== null;
}

exports.isObject = isObject;
//# sourceMappingURL=is-object.cjs.map
